// Considered: SphereIdentityAtom alone — rejected because the row needs the type
// coin (ScopeCoinAtom with hue/icon from type map) + a "type · org" sub-line +
// joined-date alongside the name, which SphereIdentityAtom (avatar+name only)
// can't express. See spec Reuse Audit.
import React from 'react';
import { useTranslation } from 'localization';
import ScopeCoinAtom from '../../atoms/marketplace/ScopeCoinAtom';
import type { SubscriberRow } from 'types/channel';
import {
  SUBSCRIBER_TYPE_HUE,
  SUBSCRIBER_TYPE_GLYPH,
  resolveSubscriberType,
} from './subscriberTypeMeta';
import './SubscriberRowMolecule.scss';

export interface SubscriberRowMoleculeProps {
  row: SubscriberRow;
}

const NS = 'marketplace.channelManage.v3Audience.drawer';

const SubscriberRowMolecule: React.FC<SubscriberRowMoleculeProps> = ({ row }) => {
  const { t } = useTranslation();
  const resolvedType = resolveSubscriberType(row.type);
  const hue = SUBSCRIBER_TYPE_HUE[resolvedType];
  const glyph = SUBSCRIBER_TYPE_GLYPH[resolvedType];
  const typeLabel = t(`${NS}.typeName.${resolvedType}`);

  const formattedDate = new Date(row.since).toLocaleDateString(undefined, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });

  return (
    <div className="subscriber-row-molecule">
      <ScopeCoinAtom
        scope="metasphere"
        glyph={glyph}
        glyphKind="icon"
        channelName={row.name}
        hue={hue}
        size="sm"
        className="subscriber-row-molecule__coin"
      />
      <div className="subscriber-row-molecule__info">
        <span className="subscriber-row-molecule__name">{row.name}</span>
        <span className="subscriber-row-molecule__meta">
          {typeLabel}
          {' · '}
          {row.org}
        </span>
      </div>
      <time className="subscriber-row-molecule__date" dateTime={row.since}>
        {formattedDate}
      </time>
    </div>
  );
};

SubscriberRowMolecule.displayName = 'SubscriberRowMolecule';
export default SubscriberRowMolecule;
